/**
 * Central query-key factory.
 *
 * Feature slices extend this with their own namespaced keys (e.g.
 * `queryKeys.actionPlans.list()`), keeping invalidation predictable across the
 * app. Each namespace exposes an `all` root so a slice can invalidate its whole
 * subtree in one call.
 */
export const queryKeys = {
  auth: {
    all: ["auth"] as const,
    me: () => [...queryKeys.auth.all, "me"] as const,
  },
} as const;
